/**
 * OAS performance helpers — delay non-critical work on weak devices.
 * Does not remove App Embed scripts (those require theme app settings).
 */
(function () {
  if (window.__oasPerfInited) return;
  window.__oasPerfInited = true;

  var SCHEDULE_MS = 1800;
  var isSlow =
    (navigator.connection &&
      (navigator.connection.saveData ||
        /2g|slow-2g|3g/i.test(navigator.connection.effectiveType || ''))) ||
    (navigator.deviceMemory && navigator.deviceMemory <= 2) ||
    (navigator.hardwareConcurrency && navigator.hardwareConcurrency <= 2);

  if (isSlow) {
    document.documentElement.classList.add('oas-perf-slow');
    SCHEDULE_MS = 3200;
  }

  function whenIdle(fn, timeout) {
    if ('requestIdleCallback' in window) {
      requestIdleCallback(fn, { timeout: timeout || 2500 });
    } else {
      setTimeout(fn, timeout || 1);
    }
  }

  function afterLoad(fn) {
    if (document.readyState === 'complete') {
      whenIdle(fn, SCHEDULE_MS);
    } else {
      window.addEventListener(
        'load',
        function () {
          whenIdle(fn, SCHEDULE_MS);
        },
        { once: true }
      );
    }
  }

  window.oasPerf = {
    isSlow: !!isSlow,
    afterLoad: afterLoad,
    whenIdle: whenIdle,
    loadScript: function (src, attrs) {
      return new Promise(function (resolve, reject) {
        if (!src) {
          resolve(null);
          return;
        }
        if (document.querySelector('script[src="' + src + '"]')) {
          resolve(null);
          return;
        }
        var s = document.createElement('script');
        s.src = src;
        s.defer = true;
        if (attrs) {
          Object.keys(attrs).forEach(function (k) {
            s.setAttribute(k, attrs[k]);
          });
        }
        s.onload = function () {
          resolve(s);
        };
        s.onerror = reject;
        document.body.appendChild(s);
      });
    }
  };

  // Soften paint cost for below-fold sections on slow devices
  afterLoad(function () {
    if (!isSlow) return;
    var main = document.getElementById('main');
    if (!main) return;
    var sections = main.querySelectorAll('.shopify-section');
    sections.forEach(function (section, index) {
      if (index < 2) return;
      section.style.contentVisibility = 'auto';
      section.style.containIntrinsicSize = '1000px';
    });
  });
})();
